import { Tabs } from "@mantine/core";
import { IconMap2, IconUser } from "@tabler/icons-react";
import classes from "../../pages/Trips/Trips.module.css";

const AllPolicyViewToggle = ({ viewMode, onViewChange }) => (
  <Tabs
    value={viewMode}
    onChange={onViewChange}
    variant="pills"
    radius="xl"
    color="orange"
    className={classes.viewToggle}
  >
    <Tabs.List>
      <Tabs.Tab value="trips" className={classes.subTab} leftSection={<IconMap2 size={14} />}>
        Trips
      </Tabs.Tab>
      <Tabs.Tab value="travellers" className={classes.subTab} leftSection={<IconUser size={14} />}>
        Travellers
      </Tabs.Tab>
    </Tabs.List>
  </Tabs>
);

export default AllPolicyViewToggle;
